import { useEventInfo } from '@shared/utils/eventInfo';

// Event-handle scope prevents leakage to non-target events (PR #14394 revert root cause).
export const STAYS_REDESIGN_EVENT_HANDLES: ReadonlySet<string> = new Set(['joy-travel', 'joy-and-travel']);

// Returns false until eventHandle resolves; safe during SSR (seeded from ssrEventInfo).
export const useIsStaysRedesignActive = (): boolean => {
  const { eventHandle } = useEventInfo();
  return !!eventHandle && STAYS_REDESIGN_EVENT_HANDLES.has(eventHandle);
};
